import { AvField, AvForm } from "availity-reactstrap-validation";
import React, { useRef, useState } from "react";
import { CardText, Col, Row } from "reactstrap";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import ContactUsService from "services/Website/ContactUsService";
import { toast } from "react-toastify";
import { SuccessOk } from "configs/statusCode";

const HearForm = () => {
	const { t } = useTranslation();
	const [formState, setFormState] = useState({
		name: "",
		email: "",
		phone: "",
		type: "",
		description: "",
	});
	const [errors, setErrors] = useState({
		name: false,
		email: false,
		phone: false,
		type: false,
		description: false,
	});
	const [loading, setLoading] = useState(false);
	const communicationTypes = [
		{ label: t("Email"), value: "Email" },
		{ label: t("Whatsapp"), value: "Whatsapp" },
		{ label: t("Zoom Meeting"), value: "Zoom Meeting" },
		{ label: t("Call"), value: "Call" },
	];

	const sumbmitFormHandler = (e, values) => {
		if (
			!formState.name ||
			!formState.phone ||
			!formState.description ||
			!formState.email ||
			!formState.type?.value
		) {
			setErrors({
				name: !formState.name,
				phone: !formState.phone,
				description: !formState.description,
				email: !formState.email,
				type: !formState.type?.value,
			});
			return;
		}
		setLoading(true);
		let data = {
			name: formState.name,
			phone: formState.phone,
			description: formState.description,
			email: formState.email,
			communication_type: formState.type.value,
		};

		new ContactUsService().contactUs(data).then((res) => {
			if (res.status === SuccessOk) {
				setLoading(false);
				setFormState({
					name: "",
					email: "",
					phone: "",
					type: "",
					description: "",
				});
				toast.success(res?.data?.success);
			}
		});
	};
	return (
		<div className="px-md-4 px-lg-0 py-md-5 pb-3">
			<div className="hearForm">
				<Row className="d-flex justify-content-center">
					<Col md={10} className="px-3">
						<div className="custom-title web-view">
							<p className="main-title">{t("WE WOULD LOVE")}</p>
							<div className="d-lg-flex">
								<p className="description-title">
									OUR CUSTOMER SERVICE team will reply to you as quickly as
									possible.
								</p>
								<p className="second-title">TO</p>
								<p className="italic-title">{t("hear from you!")}</p>
							</div>
						</div>
						<div className="custom-title mobile-view">
							<p className="main-title">{t("WE WOULD LOVE")}</p>
							<p className="second-title">TO</p>
							<p className="italic-title">{t("hear from you!")}</p>
							{/* <p
								className="main-title"
								dangerouslySetInnerHTML={{
									__html: t("We would love to hear from you title"),
								}}></p> */}
							<div className="d-lg-flex mt-3">
								<p className="description-title">
									OUR CUSTOMER SERVICE team will reply to you as quickly as
									possible.
								</p>
							</div>
						</div>
						{/* <div className="custom-title text-center pb-lg-4">
							<CardText className="textDark bask-font" tag="h2">
								{t("We would love to hear from you!")}
							</CardText>
							<CardText tag="p" className="textDarkGray ">
								{t(
									"Our customer service team will reply to youas quickly as possible."
								)}
							</CardText>
						</div> */}
						<AvForm
							className="px-3"
							onValidSubmit={(e, v) => sumbmitFormHandler(e, v)}>
							<Row className="pt-3">
								<Col lg={6} className="pb-4 custom-input">
									<AvField
										name="name"
										className="form-control text-primary rounded-3 height-50"
										label={t("Name")}
										// required
										type="text"
										value={formState?.name}
										onChange={(e) => {
											setFormState((prev) => ({
												...prev,
												name: e.target?.value,
											}));
											setErrors((prev) => ({
												...prev,
												name: false,
											}));
										}}
									/>
									{errors?.name && (
										<span className="font-size-11 text-danger">
											This field is invalid
										</span>
									)}
								</Col>
								<Col lg={6} className="pb-4 custom-input">
									<AvField
										name="email"
										className="form-control text-primary rounded-3 height-50"
										label={t("Email")}
										// required
										type="email"
										value={formState?.email}
										onChange={(e) => {
											setFormState((prev) => ({
												...prev,
												email: e.target?.value,
											}));
											setErrors((prev) => ({
												...prev,
												email: false,
											}));
										}}
									/>
									{errors?.email && (
										<span className="font-size-11 text-danger">
											This field is invalid
										</span>
									)}
								</Col>
								<Col lg={6} className="pb-4 custom-input">
									<AvField
										className="font-size-14 text-primary height-50"
										label={t("Phone")}
										name="phone"
										bsSize="lg"
										// required
										// maxLength={11}
										// minLength={11}
										type="number"
										value={formState?.phone}
										onChange={(e) => {
											setFormState((prev) => ({
												...prev,
												phone: e.target?.value,
											}));
											setErrors((prev) => ({
												...prev,
												phone: false,
											}));
										}}
									/>
									{errors?.phone && (
										<span className="font-size-11 text-danger">
											This field is invalid
										</span>
									)}
								</Col>
								<Col lg={6} className="pb-4 custom-input">
									<Select
										name="communication_type"
										placeholder={t("Type Of Communication")}
										className="selectHeight text-primary"
										style={{ height: "50px" }}
										options={communicationTypes}
										value={formState?.type}
										onChange={(e) => {
											setFormState((prev) => ({ ...prev, type: e }));
											setErrors((prev) => ({
												...prev,
												type: false,
											}));
										}}
									/>
									{errors?.type && (
										<span className="font-size-11 text-danger">
											This field is invalid
										</span>
									)}
								</Col>
							</Row>
							<AvField
								name="description"
								label={t("Your Inquiry")}
								rows="4"
								// required
								placeholder={t("Write Here")}
								type="textarea"
								className="rounded-4 pt-3 text-primary"
								value={formState?.description}
								onChange={(e) => {
									setFormState((prev) => ({
										...prev,
										description: e.target?.value,
									}));
									setErrors((prev) => ({
										...prev,
										description: false,
									}));
								}}
							/>
							{errors?.description && (
								<span className="font-size-11 text-danger">
									This field is invalid
								</span>
							)}
							<div className="text-center mt-4">
								<button
									type="submit"
									disabled={loading}
									className="btn btn btnOrange my-4 mb-md-5 mb-4 height-50 w-100 text-center"
									size={"lg"}>
									{t("Send Message")}
								</button>
							</div>
						</AvForm>
					</Col>
				</Row>
			</div>
		</div>
	);
};

export default HearForm;
